import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import VersionWatcher from './VersionWatcher';
import reportWebVitals from './reportWebVitals';
import { ClerkProvider } from '@clerk/clerk-react';
import { frFR } from '@clerk/localizations';
import { Analytics } from '@vercel/analytics/react';

const CLERK_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={CLERK_KEY || "pk_missing"}
      localization={frFR}
      appearance={{
        variables: {
          colorPrimary:         "#C9A84C",
          colorBackground:      "#07111F",
          colorText:            "#C8D8E8",
          colorInputBackground: "#0D1F33",
          colorInputText:       "#E8DCC8",
          colorNeutral:         "#7A9BB5",
          borderRadius:         "12px",
        },
      }}
    >
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
      <VersionWatcher />
      <Analytics />
    </ClerkProvider>
  </React.StrictMode>
);

reportWebVitals();
